<app-ariane-nav [label]="arianeLabel" [icon]="arianeIcon" [arianeList]="this.arianeList"></app-ariane-nav>
<mat-divider class="my-3"></mat-divider>
<div class="div-conteneur">
  <div class="row mt-4 mb-3">
    <div class="col flex-container end align-items-center">
      <div>
        <button mat-stroked-button class="bt-table-defaut mr-5" (click)="exportFinContrat()"><mat-icon>download</mat-icon>Exporter</button>
      </div>

      <div>
        <button
          mat-stroked-button
          class="bt-table-defaut mr-5"
          (click)="togglePanel()"
          [style]="panelOpenState ? 'border: 2px solid #405d9c;' : ''"
          >
          @if (!panelOpenState) {
            <mat-icon>filter_alt</mat-icon>
          }
          @if (!panelOpenState && ((activeFilterCount$ | async) ?? 0) > 0) {
            <mat-icon class="icon-filtre-check">check_circle</mat-icon>
          }

          @if (panelOpenState) {
            <mat-icon>filter_alt</mat-icon>
          }
          @if (!panelOpenState) {
            <span>
              Filtrer @if (activeFilterCount$ | async; as count) {
              <span class="filter-count">({{ count }})</span>
              }</span
              >
            }
            @if (panelOpenState) {
              <span> Liste des filtres </span>
            }
            @if (!panelOpenState) {
              <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
            }
            @if (panelOpenState) {
              <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
            }
          </button>
        </div>
      </div>
    </div>
    <mat-expansion-panel class="panel-filtre" [expanded]="panelOpenState" style="width: 100%">
      <app-fin-contrat-filter (filterApplied)="onFilterApplied($event)"></app-fin-contrat-filter>
    </mat-expansion-panel>

    <app-data-table-optimized
      [displayedColumns]="demandesDisplayedColumns"
      [getData]="getAgentsList"
      [externalFilter$]="filterSubject"
      [cellStyleCss]="demandesCellStyleCss"
      [hasView]="true"
      [hasPagination]="true"
      [selectable]="false"
      [editable]="false"
      [renewable]="true"
      [deletable]="false"
      [downloadable]="false"
      [downloadablePJ]="false"
      [downloadablePJ_hidden]="false"
      (renewItemEvent)="renouvelerContrat($event)"
      (showDetail)="viewRenewalDetails($event)"
      >
    </app-data-table-optimized>
  </div>
